import React from 'react'
import img1 from "../assets/amazon logo.png"
import img2 from "../assets/aliexpress.png"
import img3 from "../assets/zara.png"
import img4 from "../assets/corte ingles.png"
import img5 from "../assets/mediamarkt.png"
import img6 from "../assets/shein.png"
import img7 from "../assets/TEMU.png"
import img8 from "../assets/zalando.png"
import img9 from "../assets/ebay.png"
import img10 from "../assets/macys.png"
import img11 from "../assets/target.png"
import img12 from "../assets/homedepot.png"
import img13 from "../assets/apple.png"
import img14 from "../assets/bestbuy.png"
import img15 from "../assets/etsy.png"
import img16 from "../assets/walmart.png"




const Compra = () => {
    return (
        <div className="how_works  py-3 mt-10">
            <div className="canvas canvas_col">
                <h1 className="text-center fw-bold">Recibimos tus Compras Online en USA y España</h1>
                <p className='font2 mt-2 text-center'>Compártenos tu carrito de compra o envíanos los enlaces de los productos que deseas adquirir. Nosotros nos encargaremos de comprar y recepcionar. Podrás pagar tu carrito de compra en Venezuela.</p>
              
                <div className="mt-2 d-flex justify-content-center align-items-center flex-wrap gap-3">
                    <img src={img9} width={100}/>
                    <img src={img10} width={100}/>
                    <img src={img11} width={100}/>
                    <img src={img12} width={70}/>
                    <img src={img13} width={70}/>
                    <img src={img14} width={100}/>
                    <img src={img15} width={100}/>
                    <img src={img16} width={110}/>
                </div>
                <div className="mt-2 d-flex justify-content-center align-items-center flex-wrap gap-3">
                    <img src={img1} width={100}/>
                    <img src={img2} width={100}/>
                    <img src={img3} width={100}/>
                    <img src={img4} width={100}/>
                    <img src={img5} width={100}/>
                    <img src={img6} width={100}/>
                    <img src={img7} width={100}/>
                    <img src={img8} width={100}/>
                </div>
            </div>
        </div>
    )
}

export default Compra